<template>
  <v-tooltip top>
    <v-btn fab dark small color="amber darken-2" slot="activator" @click="onClick();">
      <v-icon>refresh</v-icon>
    </v-btn>
    <span>Refresh</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    onClick() {
      this.$emit("refresh");
    }
  }
};
</script>

<style>
</style>
